import { FormatPhonePipe } from '../../../../../../modules/mapfre-design-library/src/lib/_helpers/_pipes/format-phone.pipe';
import { CustomDateFormatPipe } from '../../../../../../_helpers/_pipes/custom-date-format.pipe';
import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit,Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router , RouterModule } from '@angular/router';
import { AcmicService } from '@mapfre-design-library/src/public_api';
// import {  } from '@angular/common';


@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent, CustomDateFormatPipe, FormatPhonePipe],
  selector: 'app-bn-upcoming-payment-notice',
  templateUrl: './bn-upcoming-payment-notice.component.html',
  styleUrls: ['./bn-upcoming-payment-notice.component.scss']
})
export class BnUpcomingPaymentNoticeComponent implements OnInit, OnChanges {
  
  @Input() policy: any;
  @Input() agent: any;

  policyData:any;
  paymentsDueDate: any;
  minAmountDue: number | undefined;
  showSevenDayNotice = false;
  showTodayNotice  = false;
  pastDueNotice = false;
  hideAlert: boolean;
  isAcmic: boolean;
  loading: boolean;
  outstandingBalance: any;
  priorTermBalance: any;
  nineDaysPastDue:any;
  
  upcomingPayment = false;
  hideAlertNonCancelled:boolean;
  currentMinAmtDue:any;
  paymentDate: any;
  agentPhoneNumber:string;
  // TEMP: suppress "Automatic payment scheduled" messaging until upcoming-bill autopay coverage can be confirmed; flip to false to restore
  suppressAutoPayScheduledNotice = true;
  
  constructor( 
  
    private acmicService: AcmicService,
    private router: Router) { 
      this.isAcmic = this.acmicService.isACMIC();
      this.loading = false;
      this.hideAlert = false;
     
    }
    
    
  ngOnInit(): void {
    console.log(this.policy)
    this.onGettingPolicyData();
    this.currMinAmtDue(this.policy);
    this.checkNoticeDisplay();
    this.onGettingPolicyData();
    this.agentPhoneNumber = this.policy?.agent?.agentISCPhone && this.policy?.agent?.agentISCPhone?.number
                              ? this.policy?.agent?.agentISCPhone?.number
                              : this.policy?.agent?.agentPhone?.number
    this.agentPhoneNumber = this.agentPhoneNumber?.toString().replace(/\D+/g, '');
    
  }

  ngOnChanges(changes:SimpleChanges){
    if(changes['policy']){
      this.policy=changes['policy'].currentValue;
      this.onGettingPolicyData();
    this.currMinAmtDue(this.policy);
    this.checkNoticeDisplay();
    this.onGettingPolicyData();
    this.agentPhoneNumber = this.policy?.agent?.agentISCPhone && this.policy?.agent?.agentISCPhone?.number
                              ? this.policy?.agent?.agentISCPhone?.number
                              : this.policy?.agent?.agentPhone?.number
    this.agentPhoneNumber = this.agentPhoneNumber?.toString().replace(/\D+/g, '');
    }
  }

  onGettingPolicyData(){
    this.policyData=this.policy;
  }

  checkNoticeDisplay(){

    if(!this.paymentDate) return;

    const dueDate = new Date(this.paymentDate);
    dueDate.setHours(0,0,0,0);

    const today = new Date();
    today.setHours(0,0,0,0);

    const sevenDaysBeforeDue= new Date(dueDate);
    sevenDaysBeforeDue.setDate(dueDate.getDate()-7);

    const nineDaysPastDue= new Date(dueDate);
                    
    nineDaysPastDue.setDate(dueDate.getDate()+9)
    this.showSevenDayNotice = today >= sevenDaysBeforeDue && today < dueDate;
    this.showTodayNotice = today.toDateString() === dueDate.toDateString()
    this.pastDueNotice = today > dueDate && today <= nineDaysPastDue;

    const month=(nineDaysPastDue.getMonth()+1)<10 ? '0' +(nineDaysPastDue.getMonth() + 1):(nineDaysPastDue.getMonth()+1);
    const day = nineDaysPastDue.getDate()<10 ? '0' + nineDaysPastDue.getDate() : nineDaysPastDue.getDate();
    const year =nineDaysPastDue.getFullYear()%100;
    this.nineDaysPastDue = `${month}/${day}/${year}`;
  }

  currMinAmtDue(policy){
    if (policy && policy.billingDetails?.[0]) {
      if (policy.billingDetails[0] && policy.hasPriorYearBalance) {
        this.outstandingBalance =
          policy.billingDetails[0].outstandingbalance +
          policy.priorYearBalance.theAmount;
      } else {
        this.outstandingBalance = policy.billingDetails[0].outstandingbalance;
      }

      if (policy.billingDetails[0] && policy.hasPriorYearBalance) {
        if (
          policy.policyCancellationReason &&
          (policy.policyCancellationReason.toLowerCase() ==
            'pay - non-payment of insurance premium' ||
            policy.policyCancellationReason.toLowerCase() ==
              'fpd - failure to pay deposit') &&
          policy.policyStatus != 'CANCELLED'
        ) {
          this.currentMinAmtDue =
            policy.exitDelinquencyAmount.theAmount +
            policy.priorYearBalance.theAmount;
          this.paymentDate = policy.policyCancellationEffectiveDate;
        } else {
          this.currentMinAmtDue =
            policy.billingDetails[0].amountStillDue +
            policy.priorYearBalance.theAmount;
          this.paymentDate = policy.billingDetails[0].paymentDueDate;
        }
      } else if (
        policy.policyCancellationReason &&
        (policy.policyCancellationReason.toLowerCase() ==
          'pay - non-payment of insurance premium' ||
          policy.policyCancellationReason.toLowerCase() ==
            'fpd - failure to pay deposit') &&
        policy.policyStatus != 'CANCELLED'
      ) {
        this.currentMinAmtDue = policy.exitDelinquencyAmount.theAmount;
        this.paymentDate = policy.policyCancellationEffectiveDate;
      } else {
        this.currentMinAmtDue = policy.billingDetails[0].amountStillDue;
        this.paymentDate = policy.billingDetails[0].paymentDueDate;
      }

      this.priorTermBalance =
        policy.priorYearBalance && policy.priorYearBalance.theAmount
          ? policy.priorYearBalance.theAmount
          : 0;
    }
  }

  onClose(){
    this.showTodayNotice = false;
    this.showSevenDayNotice = false;
    this.pastDueNotice= false;
    this.hideAlert = true;
  }

  payNow(){ 
    this.router.navigate(['billing-new', this.policy.policynumber?.policyNumber, 'make-a-payment']);
  }
}